// @ts-nocheck - suppress strict/type resolution errors in this legacy JS-heavy file
/// <reference path="../typings/global.d.ts" />

import { ShoppingCart } from '../common/ShoppingCart';
import { RequiredFieldBinder } from '../../common/RequiredFieldBinder'; 
import { IntakeCancelDialog } from '../../common/IntakeCancelDialog'; 
import { NavigationUtility } from '../../common/NavigationUtility';
import { ScreenLoadUtility } from '../../common/ScreenLoadUtility';
import { CISAddressTypeAhead } from '../../common/CISAddressTypeAhead';
import { ErrorHandler } from '../../common/ErrorHandler';
import { RebateEligibilitySearchFieldBinder } from '../common/RebateEligibilitySearchFieldBinder';
import { AntiForgeryUtility } from '../../common/AntiForgeryUtility'; 

export class RebateEligibilityPage {

    public static Init() {

        //Setup dynamically required fields
        var url: string = `${window.location.origin}/api/requiredfields/rebateeligibility`;
        var reqFldBinder: RequiredFieldBinder = new RequiredFieldBinder();
        reqFldBinder.SetProgramRequiredFieldsByPageApplyRules(url, "ApplicationInformation", null, false, false);
                
        RebateEligibilityPage.UnbindFields();
        RebateEligibilityPage.BindFields();
        ShoppingCart.Init();
        RebateEligibilitySearchFieldBinder.Init();

        //If no app is in session, this will load all the cards in a disabled state.
        RebateEligibilityPage.LoadRebateCardList(true);
    }

    private static BindFields() {

        IntakeCancelDialog.BindConfirmCancelButton();
        NavigationUtility.ReloadPageOnBackButtonNavigation();
        
        $("input[name='ApplicationInformation.FuelTypeInformation.CurrentHouseFuelTypeId']").on("change", (e) => {
            this.ToggleHeatingSystemButtons(e.currentTarget.id);
        });

        //Set the initial statue of the heating system types
        RebateEligibilityPage.SetHeatingSystemVisibility();

        //Try to stop autofill for typeahead
        $("#ApplicationInformation_EligibilityInfo_TypeaheadAddress").prop('autocomplete', 'chrome-off');

        $(".icf-filter-rebate").on('click', (e) => {
            //$.event.trigger('icf-eligibility-selected');
            RebateEligibilityPage.LoadRebateCardList(false);
        });

        //single path checkout
        $("#btn-sp-checkout").on('click', (e) => {
            var url: string = e.currentTarget.getAttribute("href");
            RebateEligibilityPage.SubmitForm(url);
            return false;
        });

        $(document).on('icf-eligibility-selected', (e, d) => {

            var typeaheadName: string = "ApplicationInformation_EligibilityInfo_TypeaheadAddress";
            CISAddressTypeAhead.RevertTypeaheadFieldName(typeaheadName);

            //Serialize data (with correct typeahead field name)
            var datax = $("#divEligibility :input").serialize();

            //Reset typeahead field to be unique
            CISAddressTypeAhead.InitTypeaheadFieldName();


            ScreenLoadUtility.StartLoadingScreen();
            var url: string = `${window.location.origin}/Rebate/Eligibility/VerifyEligibility`;
            $.ajax({
                url: url,
                headers: AntiForgeryUtility.SetForgeryFromTokenInHeader(),
                data: datax,
                type: 'POST'
            }).done((result) => {
                if (result.IsJsonResponse) {
                    if (result.RedirectUrl) {
                        window.location.href = result.RedirectUrl
                    } else {
                        ErrorHandler.HandleError(result, false);
                    }
                } else {
                    $("#eligibilityDiv").html(result);

                    // Re-apply program-specific required field labels/rules after partial refresh
                    const requiredUrl: string = `${window.location.origin}/api/requiredfields/rebateeligibility`;
                    const reqFldBinder: RequiredFieldBinder = new RequiredFieldBinder();
                    reqFldBinder.SetProgramRequiredFieldsByPageApplyRules(
                        requiredUrl,
                        "ApplicationInformation",
                        () => {
                            RebateEligibilitySearchFieldBinder.Init();
                            ScreenLoadUtility.StopLoadingScreen();
                            RebateEligibilityPage.LoadRebateCardList(false);
                        },
                        false,
                        false
                    );
                }
            }).fail((xhr) => {
                ErrorHandler.HandleError(xhr);
            }).always((xhr) => {
                //ScreenLoadUtility.StopLoadingScreen();
            });

        });

        $(document).on('icf-eligibility-deselected', (e, d) => {
            RebateEligibilityPage.LoadRebateCardList(false);
        });

    }

    private static UnbindFields() {
        $('.icf-filter-rebate').off('click');
        $('#btn-sp-checkout').off('click');
        $(document).off('icf-eligibility-selected');
        $(document).off('icf-eligibility-deselected');
    }

    private static LoadRebateCardList(init) {

        if (!$("#rebateCardDiv").length) {
            //Screen does not have the rebate card section, so ignore.
            return;
        }

        let applicationId: string = $("#applicationId").val() as string;
        let accountUrl : string = `${window.location.origin}/Rebate/Eligibility/BindRebateCardList/${applicationId}`;
        if (init) {
            accountUrl += '?init=true';
        } else {
            accountUrl += '?init=false';
        }

        //@* Had trouble pass the cards, didnt need them to load the cards. *@
        var datax = $("#validate-form :input:not([name *= CardList])").serialize();

        ScreenLoadUtility.StartLoadingScreen();
        $.ajax({
            url: accountUrl,
            headers: AntiForgeryUtility.SetForgeryFromTokenInHeader(),
            data: datax,
            type: 'POST'
        }).done((result) => {
            $("#rebateCardDiv").html(result);
            $(".icf-equipment-card-link").off('click');
            $(".icf-equipment-card-link").on('click', (e) => {
                e.preventDefault();
                var url: string = e.currentTarget.getAttribute("href");
                RebateEligibilityPage.SubmitForm(url);
                return false;
            });
        }).fail((xhr) => {
            ErrorHandler.HandleError(xhr);
        }).always((xhr) => {
            ScreenLoadUtility.StopLoadingScreen();
        });

    }

    private static SubmitForm(url: string): void {
        if (!$("#validate-form").valid()) {
            var errorDiv = $('.field-validation-error:visible').first();
            var scrollPos = errorDiv.offset().top;
            $(window).scrollTop(scrollPos);
            return;
        }

        CISAddressTypeAhead.RevertTypeaheadFieldName("ApplicationInformation_EligibilityInfo_TypeaheadAddress");
        var datax = $("#validate-form").serialize();
        CISAddressTypeAhead.InitTypeaheadFieldName();

        //Note: TS vs JS. To get this context, must user (result)=> instead of function(result)
        var jqxhr = $.post(url, datax, (result) => {
            //alert("success - " + JSON.stringify(result));
            if (result.IsJsonResponse) {
                //Possible session timeout
                if (result.RedirectUrl) {
                    window.location.href = result.RedirectUrl
                }
            } else {
                //reloads form with new html (_EligiblityCheckForm.cshtml)
                $("#eligibility-form-div").html(result);
                RebateEligibilityPage.Init();

                var errorDiv = $('.field-validation-error:visible').first();
                var scrollPos = errorDiv.offset().top;
                $(window).scrollTop(scrollPos);
            }
        }).done(function (result) {
        }).fail(function (xhr) {
            ErrorHandler.HandleError(xhr, false);
        }).always(function () {

        });
    }

    private static ToggleHeatingSystemButtons(currentHouseHeatingFuelType: string) {

        $("input[name='ApplicationInformation.FuelTypeInformation.AllHeatingSystemTypeId']:radio").prop('checked', false);
        RebateEligibilityPage.ShowHideHeatingSystemTypeByFuelType(currentHouseHeatingFuelType);
        return;
    }

    private static ShowHideHeatingSystemTypeByFuelType(currentHouseHeatingFuelType: string) {

        if (currentHouseHeatingFuelType == 'ft_FuelTypeGas') {
            RebateEligibilityPage.DisableGasHeatingSystemTypes(false);
            RebateEligibilityPage.DisableElectricHeatingSystemTypes(true);
        } else if (currentHouseHeatingFuelType == 'ft_FuelTypeElectric') {
            RebateEligibilityPage.DisableGasHeatingSystemTypes(true);
            RebateEligibilityPage.DisableElectricHeatingSystemTypes(false);
        } else {
            RebateEligibilityPage.DisableGasHeatingSystemTypes(false);
            RebateEligibilityPage.DisableElectricHeatingSystemTypes(false);
        }
    }

    private static DisableGasHeatingSystemTypes(disableFlag: boolean) {
        $("input[id=hst_HeatingSystemBoiler]").prop('disabled', disableFlag);
        $("input[id=hst_HeatingSystemFurnace]").prop('disabled', disableFlag);
    }

    private static DisableElectricHeatingSystemTypes(disableFlag: boolean) {
        $("input[id=hst_HeatingSystemElectricResistance]").prop('disabled', disableFlag);
        $("input[id=hst_HeatingSystemForcedAir]").prop('disabled', disableFlag);
        $("input[id=hst_HeatingSystemHeatPump]").prop('disabled', disableFlag);
        $("input[id=hst_HeatingSystemElectricFurnace]").prop('disabled', disableFlag);
        $("input[id=hst_HeatingSystemRadiant]").prop('disabled', disableFlag);
        $("input[id=hst_Other]").prop('disabled', disableFlag);
    }

    private static SetHeatingSystemVisibility() {
        var currentHouseHeatingFuelType = $("input[name='ApplicationInformation.FuelTypeInformation.CurrentHouseFuelTypeId']:checked").attr("id");
        if (currentHouseHeatingFuelType) {
            RebateEligibilityPage.ShowHideHeatingSystemTypeByFuelType(currentHouseHeatingFuelType.toString());
        }
    }

}

((window: any, document: any) => {
    $(() => {
        RebateEligibilityPage.Init();
    });
})(window, document);